import React  from 'react';
import "./Admission.css";


import AdmissionForm from '../components/AdmissionForms/AdmissionForm';
 const Admission = ()=> {
 
    return <div>
        <AdmissionForm/>
    </div>;
 
}

export default Admission;
